import React, { useState } from "react";
import TabComponent from "../../reusableComponents/tab/TabComponent";
import Litigation from "./Litigation";
import PotentialLitigation from "./PotentialLitigation";
import Fraud from "./Fraud";
import Suspicious from "./Suspicious";

const ClaimLitigation = (props) => {
  const { claimDetailCookie, roleDataCookie, getClaimDetails } = props;
  const claimLitigationTabs = [
    // { key: "fraud", label: "Fraud" },
    { key: "potentialLitigation", label: "Potential Litigation" },
    { key: "claimLitigation", label: "Litigation" },
    { key: "suspicious", label: "Suspicious" }
  ];
  const [claimActiveTab, setClaimActiveTab] = useState(claimLitigationTabs[0]?.key);
  const handleClaimTabClick = (tabName) => {
    setClaimActiveTab(tabName);
  };

  return (
    <div
      className={
        claimDetailCookie
          ? "inner-box2Field mt-3"
          : "claim-processing-tabs bg-white rounded"
      }
    >
      <div className="mt-3">
        <TabComponent
          tabs={claimLitigationTabs}
          activeTab={claimActiveTab}
          handleTabClick={handleClaimTabClick}
        />
      </div>
      {claimActiveTab === "fraud" && (
        <Fraud
          claimDetailCookie={claimDetailCookie}
          roleDataCookie={roleDataCookie}
          getClaimDetails={getClaimDetails}
        />
      )}
      {claimActiveTab === "potentialLitigation" && (
        <PotentialLitigation
          claimDetailCookie={claimDetailCookie}
          roleDataCookie={roleDataCookie}
          getClaimDetails={getClaimDetails}
        />
      )}
      {claimActiveTab === "claimLitigation" && (
        <Litigation
          claimDetailCookie={claimDetailCookie}
          roleDataCookie={roleDataCookie}
          getClaimDetails={getClaimDetails}
        />
      )}
      {claimActiveTab === "suspicious" && (
        <Suspicious
          claimDetailCookie={claimDetailCookie}
          roleDataCookie={roleDataCookie}
          getClaimDetails={getClaimDetails}
        />
      )}
    </div>
  );
};

export default ClaimLitigation;